import React from 'react'
import { useMessage } from '../../hooks/message'
import { HOUSE_EXPENSE_LIST } from '../../urls'
import { usePostRequest } from '../../hooks/request'
import BuildingExpenseForm from './BuildingExpenseForm'

export default function BuildingExpenseCreate({ onCancel, categoryList, expenseReport, brandList, buildId }) {
    const products = usePostRequest({ url: HOUSE_EXPENSE_LIST })
    const [showMessage] = useMessage()

    async function onSubmit(data) {
        const { success, error } = await products.request({
            data: {
                ...data,
                building: buildId,
            },
        })
        if (success) {
            expenseReport.request()
            onCancel()
        }
        if (error) showMessage(error?.data?.detail || 'Ошибка', 'is-danger')
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Қўшиш</b>
            </h1>
            <BuildingExpenseForm loading={products.loading} categoryList={categoryList} brandList={brandList} onCancel={onCancel} onSubmit={onSubmit} />
        </div>
    )
}
